class DFFWorkOrderService {
  static setWorkOrder = (api, configuration, workOrderTriggers) => {
    api.onFieldWorkOrdersChange(configuration.section, configuration.id, workOrderTriggers);
  };
}

export default DFFWorkOrderService;